import { ErrorMessage } from '@hookform/error-message';
import PropTypes from 'prop-types';
import React from 'react';
import { useController } from 'react-hook-form';
import { Label, Input, Error } from './styles';

function FieldCNPJ(props) {
  const { control, name, label, errors, ...rest } = props;
  const { onChange: onChangeFromProps, ...otherProps } = rest;

  const {
    field: { ref, ...inputProps },
  } = useController({
    name,
    control,
  });

  const handleChange = event => {
    event.target.value = (event.target.value || '').toUpperCase();
    inputProps.onChange(event);

    if (onChangeFromProps) {
      onChangeFromProps(event);
    }
  };

  return (
    <>
      {label && (
        <Label htmlFor={name} style={{ paddingRight: '10px' }}>
          {label}
        </Label>
      )}
      <Input
        id={name}
        {...inputProps}
        {...otherProps}
        ref={ref}
        onChange={handleChange}
        mask="aa.aaa.aaa/aaaa-99"
        formatChars={{ a: '[A-Z0-9]', 9: '[0-9]' }}
      />
      {errors && <ErrorMessage as={Error} errors={errors} name={name} />}
    </>
  );
}

FieldCNPJ.propTypes = {
  control: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  errors: PropTypes.object,
  label: PropTypes.string,
};

export default FieldCNPJ;
